import type { QueryClient } from '@tanstack/react-query';

import { COMPANY_NAME } from '../constants';
import type {
  AppShellApiClient,
  ErrorLogger,
  IMerchantPaymentSettingsV2,
} from '../shared/types';
import createQueryConfig from '../queries';

interface FetchMerchantPaymentSettingsParams {
  merchantId: string;
  featureToggles?: { paypal_payment_enabled?: boolean; [key: string]: unknown };
  apiClient: AppShellApiClient;
  queryClient: QueryClient;
  errorLogger: ErrorLogger;
}

export async function fetchMerchantPaymentSettings({
  merchantId,
  featureToggles,
  apiClient,
  queryClient,
  errorLogger,
}: FetchMerchantPaymentSettingsParams): Promise<Pick<
  IMerchantPaymentSettingsV2,
  'payment_methods'
> | null> {
  try {
    const queryConfig = createQueryConfig(queryClient, apiClient);
    const { queryKey, queryFn } = queryConfig.merchantPaymentSettingsV2({
      merchantId,
    });
    const response = (await queryClient.fetchQuery({
      queryKey,
      queryFn,
    })) as IMerchantPaymentSettingsV2;
    const isPayPalFeatureToggleEnabled =
      featureToggles?.paypal_payment_enabled || false;

    const paymentMethods =
      response.payment_methods.filter(({ name, status }) => {
        if (!isPayPalFeatureToggleEnabled && name === 'paypal') {
          return false;
        }
        if (COMPANY_NAME !== 'shore' && name === 'shorepay_online') {
          return false;
        }
        if (name === 'stripe' && status === 'not_setup') {
          return false;
        }
        return true;
      }) || [];

    return {
      payment_methods: paymentMethods,
    };
  } catch (error) {
    errorLogger.log(error as Error, { merchantId });
    return null;
  }
}
